import VisibilitySettingsContainer from './components/VisibilitySettingsContainer';

export default VisibilitySettingsContainer;
